import React, { useState, useEffect, useRef, useMemo } from 'react';
import styles from './FollowersList.module.css';
import { HiEye, HiUserPlus, HiCheckCircle, HiXCircle, HiUserGroup, HiTrash, HiArrowTrendingUp } from 'react-icons/hi2';
import { useTranslation } from 'react-i18next';
import avatar from './../../../assets/default-avatar.svg';
import VirtualFriendsList from './../VirtualFriendsList/VirtualFriendsList';


export default function FollowersList({ followers, onView, isLoading }) {
  const [search, setSearch] = useState('');
  const { t } = useTranslation();
	// Group by status
	const groups = useMemo(() => {
		const map = { online: [], away: [], offline: [] };
		if (!Array.isArray(followers)) return map;

		followers.forEach(f => {
			const key = ['online', 'away', 'offline'].includes(f.status) ? f.status : 'offline';
			map[key].push(f);
		});
		return map;
	}, [followers]);

	const filteredGroups = useMemo(() => {
		if (!followers || !Array.isArray(followers)) return { online: [], away: [], offline: [] };

		const query = search.toLowerCase();
		return Object.fromEntries(
		Object.entries(groups).map(([key, arr]) => [
		  key,
		  arr.filter(f => f.username?.toLowerCase().includes(query))
		])
		);
	}, [groups, search, followers]);

	if (isLoading) {
		return <div className={styles.loading}>Loading followers...</div>;
		return <div className={styles.loading}>Loading followers...</div>;
	}

	const allEmpty = Object.values(filteredGroups).every(g => g.length === 0);

  return (
    <div className={styles.section}>
      <h4 className={styles.sectionTitle}><HiEye /> {t('friends.followers')}</h4>
		  <div className={styles.container}>
			<input
			  className={styles.search}
			  type="search"
			  placeholder="Search..."
			  value={search}
			  onChange={(e) => setSearch(e.target.value)}
			/>

			{allEmpty ? (
				<div className={styles.empty}>
					{t('friends.noFollowers')}
				</div>
			) : (
			  Object.entries(filteredGroups).map(([status, arr]) => (
				arr.length > 0 && (
				  <div key={status} className={styles.group}>
					<h5 className={styles.groupTitle}>{status.charAt(0).toUpperCase() + status.slice(1)}</h5>
					<VirtualFriendsList
					  friends={arr}
					  onView={onView}
					  onRemove={null}
					  onAccept={null}
					  onUnfollow={null}
					  onDecline={null}/>
				  </div>
				)
			  ))
			)}
		  </div>
    </div>
  );
}
